<!-- クライアントマスタ　一覧画面 -->
<style src="@/assets/css/admin_parts.css" type="text/css" media="all" scoped></style>
<template>
	<div class="contents" id="wjgyo">
		<!-- ▽  -->
		<section id="mainContent">
			<h2>クライアントマスタ</h2>
			<ul class="contntMenu">
				<li class="onBack" v-on:click="onBack">TOP</li>
			</ul>
			<!-- ▽  -->
			<section>
				<table class="listTbl">
					<caption>
						<div class="btnLst">
							<button class="newBtn" v-on:click="onRegister">新規作成</button>
						</div>
					</caption>
					<thead>
						<tr>
							<th>名称</th>
							<td>保険者番号</td>
							<td>使用可能</td>
							<td class="btnLst"></td>
						</tr>
					</thead>
					<tbody>
						<tr v-for="list in displayLists" v-bind:key="list.JGCD">
							<th>
								{{list.JGNM}}
							</th>
							<td>
								{{list.HKSH}}
							</td>
							<td>
								{{list.VSBLDisplay}}
							</td>
							<td class="btnLst">
								<button class="detailBtn" v-on:click="onDetail(list.JGCD)">詳細</button>
								<button class="dltBtn" v-on:click="onDeleteSub(list.JGCD)">削除</button>
							</td>
						</tr>
					</tbody>
				</table>
				<!--データが一件もない場合に表示-->
				<div v-if="displayLists.length == 0">
					<p>データが一件も登録されていません。</p>
				</div>
			</section>
			<!-- △  END -->
		</section>
		<!-- △ mainContents END -->
		<!--モーダルWindow S -->
		<modalWindow v-show="modal.deleteRow.isShow" v-on:close="onDeleteRowModalClose">
			<dt slot="modal-header">確認</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.deleteRow.messages"></errorMessageBox>
				<ul class="btnLst">
					<li><button v-on:click="onDelete">削除</button></li>
					<li><button v-on:click="onCancel">キャンセル</button></li>
				</ul>
			</dd>
			<dd slot="modal-footer"></dd>
		</modalWindow>
		<!--モーダルWindow E -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.systemError.isShow" v-on:close="onSystemErrorModalClose">
			<dt slot="modal-header">システムエラー</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.systemError.messages"></errorMessageBox>
			</dd>
			<dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onSystemErrorModalClose">閉じる</a></dd>
		</modalWindow>
		<!-- モーダルWindow E -->
	</div>
</template>

<script>
	import { WJGYOListApi } from '@/api'
	import * as types from '@/store/mutation-types'
	import * as ErrorCodes from '@/components/Utility/error-codes'
	import ErrorMessageBox from '@/components/Utility/ErrorMessageBox'
	import ModalWindow from '@/components/Utility/ModalWindow'
	import { WJGYOListDeleteApi } from '@/api'
  import * as UtilityConsoleLog from '@/components/Utility/UtilityConsoleLog'

	export default {
		name: 'MasterWJGYOList',
		// 使用コンポーネント
		components: {
			// エラーメッセージ
			errorMessageBox: ErrorMessageBox,
			// モーダルウィンドウ
			modalWindow: ModalWindow
		},
		data() {
			return {
				// リスト表示用配列
				displayListsSub: [],
				displayLists: [],
				// モーダルウィンドウ
				modal: {
					deleteRow: {
						messages: [
							'削除しますか？'
						],
						isShow: false
					},
					systemError: {
						messages: [
							'システムエラーです。',
							'内容をもう一度ご確認ください。'
						],
						isShow: false
					}
				},
			}
		},
		created: function () {
			UtilityConsoleLog.consoleLog('MasterWJGYOList::created Start')

			var tempircd = this.$store.state.auth.ircd

			// 非同期通信
			WJGYOListApi.FirstDisplay({
				token: this.$store.state.auth.token,
				ircd: tempircd
			}).then(({ responce }) => {

				if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

					var tempLists = responce.data.listJGYO

					// リスト表示用配列の作成
					tempLists.forEach((list) => {

						// VSBLをVSBLDisplayにコード値変換
						var tempJGYODisplay = this.createJGYODisplay(list.VSBL)              

						this.displayLists.push({
							IRCD: list.IRCD,
							JGCD: list.JGCD,
							JGNM: list.JGNM,
							HKSH: list.HKSH,
							VSBL: list.VSBL,
							VSBLDisplay: tempJGYODisplay,                
						})
					})

				} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
					|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
					|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
					// システム、DBエラー時
					this.onSystemErrorModalOpen()
				}
			}).catch(() => {
				this.onSystemErrorModalOpen()
			}).finally(() => {
				UtilityConsoleLog.consoleLog('MasterWJGYOList::created End')
			})
		},
		methods: {
			//新規作成ボタン
			onRegister: function () {
				UtilityConsoleLog.consoleLog("MasterWJGYOList::onRegister Start")

				//新規作成画面に遷移
				this.$router.push("/MasterWJGYORegister")

				UtilityConsoleLog.consoleLog("MasterWJGYOList::onRegister End")
			},
			// メニューへ戻る
			onBack: function () {
				UtilityConsoleLog.consoleLog("MasterWJGYOList::onBack Start")

				this.$router.push("/AdminReserveStatusCheck")

				UtilityConsoleLog.consoleLog("MasterWJGYOList::onBack End")
			},
			//VSBLのコード値変換
			createJGYODisplay(VSBL) {

				var tempJGYODisplay = ''

				if (VSBL == '1') {
					tempJGYODisplay = '可'
				} else if (VSBL == '2') {
					tempJGYODisplay = '不可'
				}
				return tempJGYODisplay
			},
			//詳細ボタン
			onDetail: function (in_jgcd) {
				UtilityConsoleLog.consoleLog("MasterWJGYOList::onDetail Start")

				//該当のJGCDをstoreに登録
				this.$store.commit(types.ADMIN_USERCHOICE_WJGYO_LISTTODETAIL, { jgcd: in_jgcd })

				//詳細画面に遷移
				this.$router.push("/MasterWJGYODetail")

				UtilityConsoleLog.consoleLog("MasterWJGYOList::onDetail End")
			},
			//削除ボタン
			onDeleteSub: function (in_jgcd) {
				UtilityConsoleLog.consoleLog("MasterWJGYOList::onDeleteSub Start")

				//該当のJGCDをstoreに登録
				this.$store.commit(types.ADMIN_USERCHOICE_WJGYO_LISTTODETAIL, { jgcd: in_jgcd })

				//削除確認モーダルを開く
				this.onDeleteRowModalOpen()

				UtilityConsoleLog.consoleLog("MasterWJGYOList::onDeleteSub End")
			},
			//削除確認モーダルでの削除ボタン
			onDelete: function () {
				UtilityConsoleLog.consoleLog("MasterWJGYOList::onDelete Start")

				var tempircd = this.$store.state.auth.ircd
				var tempjgcd = this.$store.state.adminUserChoice.MasterWJGYO.jgcd

				WJGYOListDeleteApi.ListDelete({
					token: this.$store.state.auth.token,
					ircd: tempircd,
					jgcd: tempjgcd

				}).then(({ responce }) => {

						if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

							var tempLists = responce.data.listJGYO

							//配列の初期化
							this.displayListsSub = []

							// リスト表示用配列の作成
							tempLists.forEach((list) => {

								// VSBLをVSBLDisplayにコード値変換
								var tempJGYODisplay = this.createJGYODisplay(list.VSBL)

								this.displayListsSub.push({
									IRCD: list.IRCD,
									JGCD: list.JGCD,
									JGNM: list.JGNM,
									HKSH: list.HKSH,
									VSBL: list.VSBL,
									VSBLDisplay: tempJGYODisplay,
								})
							})

							//画面再描画用
							this.displayLists = this.displayListsSub

							//モーダルウィンドウを閉じる
							this.modalClose('deleteRow')

							// ストア値を初期化
							this.$store.commit(types.ADMIN_USERCHOICE_WJGYO_LISTTODETAIL, { jgcd: '' })

						} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
							|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
							|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
							// システム、DBエラー時
							this.onSystemErrorModalOpen()
						}
					}).catch(() => {
						// システムエラー時
						this.onSystemErrorModalOpen()
					}).finally(() => {
						UtilityConsoleLog.consoleLog('MasterWJGYOList::onDelete End')
					})
			},
			// 削除確認モーダルとしてエラーモーダルを開く
			onDeleteRowModalOpen: function () {
				UtilityConsoleLog.consoleLog('MasterWJGYOList::onDeleteRowModalOpen Start')

				this.modalOpen('deleteRow')

				UtilityConsoleLog.consoleLog('MasterWJGYOList::onDeleteRowModalOpen End')
			},
			// 削除確認モーダルとしてエラーモーダルを閉じる
			onDeleteRowModalClose: function () {
				UtilityConsoleLog.consoleLog('MasterWJGYOList::onDeleteRowModalClose Start')

				this.modalClose('deleteRow')

				UtilityConsoleLog.consoleLog('MasterWJGYOList::onDeleteRowModalClose End')
			},
			//一覧表示画面に戻る
			onCancel: function () {
				UtilityConsoleLog.consoleLog("MasterWJGYOList::onCancel Start")

				this.$store.commit(types.ADMIN_USERCHOICE_WJGYO_LISTTODETAIL, {})

				this.modalClose('deleteRow')

				UtilityConsoleLog.consoleLog("MasterWJGYOList::onCancel End")
			},
			// システムエラーモーダルとしてエラーモーダルを開く
			onSystemErrorModalOpen: function () {
				UtilityConsoleLog.consoleLog('MasterWJGYOList::onSystemErrorModalOpen Start')

				this.modalOpen('systemError')

				UtilityConsoleLog.consoleLog('MasterWJGYOList::onSystemErrorModalOpen End')
			},
			// システムエラーモーダルウィンドウの閉じるボタン
			onSystemErrorModalClose: function () {
				UtilityConsoleLog.consoleLog('MasterWJGYOList::onSystemErrorModalClose Start')

				this.modalClose('systemError')
				this.$router.push("/AdminLogin")

				UtilityConsoleLog.consoleLog('MasterWJGYOList::onSystemErrorModalClose End')
			},
			// モーダルウィンドウを開く
			modalOpen: function (modalName) {
				UtilityConsoleLog.consoleLog('MasterWJGYOList::modalOpen Start')

				// すべてのモーダルを閉じる
				this.allModalClose()

				this.modal[modalName].isShow = true

				UtilityConsoleLog.consoleLog('MasterWJGYOList::modalOpen End')
			},
			// モーダルウィンドウを閉じる
			modalClose: function (modalName) {
				UtilityConsoleLog.consoleLog('MasterWJGYOList::modalClose Start')

				this.modal[modalName].isShow = false

				UtilityConsoleLog.consoleLog('MasterWJGYOList::modalClose End')
			},
			// 全てのモーダルを閉じる
			allModalClose: function() {  
				for(var key in this.modal) {
					this.modal[key].isShow = false
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Master/WJGYO/MasterWJGYOList.vue